import { IViewOnlyQuestion } from 'shared-components';

export function initializeFreeFormAnswersIfNotExist(question: IViewOnlyQuestion): void {
  if (!question.FreeFormAnswers) {
    question.FreeFormAnswers = [];
  }
}
